<div class="spinner-container">
    <div class="rvh-loader-logo-sec">
        <img class="rvh-publisher-logo" src="./assets/logos/publisher_logo.png">
    </div>
    <div class="spinner"></div>
</div>